import './NotFound.scss'

import React, {Component} from 'react';

import { connect } from 'react-redux'
import { push } from 'react-router-redux'

class NotFound extends Component {

  render() {
    return (
      <div className="NotFound">
        <div className="NotFound__content">
          <div className="NotFound__icon NotFound__icon--not-found">
            <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
          </div>
          <div className="NotFound__title">Not Found</div>
          <div className="NotFound__body">We were unable to resolve your request.</div>
          <div className="NotFound__return-button">
            <button  onClick={() => { window.location = '/' } }>Return Home</button>
          </div>
        </div>
      </div>
    )
  }

}

export default NotFound
